import { render, staticRenderFns } from "./VerifiedMask.vue?vue&type=template&id=6e2c560a&scoped=true"
import script from "./VerifiedMask.vue?vue&type=script&lang=js"
export * from "./VerifiedMask.vue?vue&type=script&lang=js"
import style0 from "./VerifiedMask.vue?vue&type=style&index=0&id=6e2c560a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c560a",
  null
  
)

export default component.exports